import {useComplianceBusyStore} from "@/src/modules/core/store/compliance-busy";

/**
 * Whether blocking gates should currently be deferred behind the sticky bar.
 * True while a dirty sheet is open and the user is active; flips to false once the idle
 * window elapses (the store's single timer), so deferred gates always eventually escalate.
 */
export function useComplianceDeferred(): boolean {
  return useComplianceBusyStore((state) => state.deferred);
}
